import { Button, Col, Descriptions, Row, Tag } from 'antd';
import styled from 'styled-components';
import Title from 'antd/lib/typography/Title';
import { Image } from 'antd';

import { styledDescriptions, styledTable } from '../styled/mixin';
import { maskingRrn, phoneFormatter } from '../../util/utils';
import {
  Vendor,
  VendorWorkerWageForm,
  vendorWorkerWageFormKorean,
} from '../../modules/vendors';
import AttachedFileListComponent from '../tasks/AttachedFileListComponent';
import { useState } from 'react';
import PDFViewModal2 from '../expenses/PDFViewModal2';

interface VendorWorkerDetailComponentProps {
  vendor: Vendor;
  downloadFile: (attachFileId: string, fileName: string) => void;
  moveToEditPage?: () => void;
}

const StyledDiv = styled.div`
  ${styledDescriptions}
  ${styledTable}
`;

function VendorWorkerDetailComponent({
  vendor,
  downloadFile,
  moveToEditPage,
}: VendorWorkerDetailComponentProps) {
  const [visible, setVisible] = useState(false);
  const [imageData, setImageData] = useState<any>();
  const [previewFileType, setPreviewFileType] = useState<string>('');

  const openImagePreview = (file: any) => {
    setImageData(file);
    setVisible(true);
    if (file.name.split('.').pop() === 'pdf') {
      setPreviewFileType('pdf');
    } else if (
      file.name.split('.').pop() === 'jpeg' ||
      file.name.split('.').pop() === 'jpg' ||
      file.name.split('.').pop() === 'png'
    ) {
      setPreviewFileType('image');
    } else {
      setPreviewFileType('');
    }
  };

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={3}>작업자 상세</Title>
        </Col>
        {moveToEditPage && (
          <Col>
            <Button size="small" onClick={moveToEditPage}>
              수정하기
            </Button>
          </Col>
        )}
      </Row>
      <Descriptions
        // title="작업자 정보"
        bordered
        column={3}
        size="small"
        // style={{ marginTop: '10px' }}
        // extra={
        //   <Space>
        //     {moveToEditPage && (
        //       <Button size="small" onClick={moveToEditPage}>
        //         수정하기
        //       </Button>
        //     )}
        //   </Space>
        // }
      >
        <Descriptions.Item label="이름">
          {vendor.application.general.name}
        </Descriptions.Item>
        <Descriptions.Item label="주민등록번호">
          {vendor.application.general.residentNumber === undefined
            ? null
            : maskingRrn(vendor.application.general.residentNumber)}
        </Descriptions.Item>

        <Descriptions.Item label="주소">
          {vendor.application.general.address}
        </Descriptions.Item>
        <Descriptions.Item label="회사전화번호">
          {vendor.application.general.personalPhoneNumber === undefined
            ? null
            : phoneFormatter(vendor.application.general.personalPhoneNumber, 1)}
        </Descriptions.Item>
        <Descriptions.Item label="직종">
          {vendor.application.general.jigjong === undefined
            ? null
            : vendor.application.general.jigjong.map((tag: any, index: any) => (
                <Tag key={index}>{tag}</Tag>
              ))}
        </Descriptions.Item>
        <Descriptions.Item label="급여수준">
          {vendor.application.general.jobLevel === undefined
            ? null
            : vendor.application.general.jobLevel === '1'
            ? '기공'
            : '조공'}
        </Descriptions.Item>
        <Descriptions.Item label="급여방식">
          {vendor.application.general.wageForm === undefined
            ? null
            : vendorWorkerWageFormKorean[
                vendor.application.general.wageForm as VendorWorkerWageForm
              ]}
        </Descriptions.Item>
        <Descriptions.Item label="은행명">
          {vendor.application.accountInfo.bankName}
        </Descriptions.Item>
        <Descriptions.Item label="예금주">
          {vendor.application.accountInfo.accountHolder}
        </Descriptions.Item>
        <Descriptions.Item label="계좌번호">
          {vendor.application.accountInfo.accountNumber}
        </Descriptions.Item>
        <Descriptions.Item label="공정">{vendor.gongjong}</Descriptions.Item>
        <Descriptions.Item label="용도">{vendor.category}</Descriptions.Item>
        <Descriptions.Item
          label="설명"
          style={{ whiteSpace: 'pre-wrap' }}
          span={2}
        >
          {vendor.description}
        </Descriptions.Item>
      </Descriptions>
      <div style={{ marginTop: '20px' }}>
        <AttachedFileListComponent
          attachedFiles={vendor.attachedFiles}
          downloadFile={downloadFile}
          openImagePreview={openImagePreview}
        />
      </div>
      {imageData && previewFileType === 'image' && (
        <Image
          width={200}
          style={{ display: 'none' }}
          preview={{
            visible,
            src: imageData?.url,
            onVisibleChange: (value) => {
              setVisible(value);
              setImageData(null);
              setPreviewFileType('');
            },
          }}
        />
      )}
      {imageData && previewFileType === 'pdf' && (
        <PDFViewModal2
          visible={!!imageData}
          url={imageData.url}
          onCancel={() => {
            setImageData(null);
            setPreviewFileType('');
          }}
          onDownload={() => downloadFile(imageData.id, imageData.name)}
        />
      )}
    </StyledDiv>
  );
}

export default VendorWorkerDetailComponent;
